import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import Header from '../../components/Header';
import { onGoBack } from '../../common/globals';
import withGoBack from '../../common/withGoBack';
import {
  getHospitalByCustomerNo,
  getTableCaseByCaseId,
  updateTableWiseCaseByCaseId,
  updateTableCaseByPrimaryId,
} from '../../utils/db';
import Bugsnag from '../../helpers/bugsnag';
import withTableName from '../../common/withTableName';
import withOnline from '../../common/withOnline';
import withLoader from '../../common/withLoader';
import withNotify from '../../common/withNotify';
import withUser from '../../common/withUser';
// import SelectFileOrTakePhoto from '../../components/Models/SelectFileOrTakePhoto';
import {
  listSingleCase,
  updateCase,
  uploadDgr,
  getCaseProductItems,
} from '../../utils/utils';
import CaseChangesNoLonger from '../../components/Models/CasesChangesNoLonger';
import VelysLogoBlue from '../../assets/images/VELYS-Logo-Blue.png';
// import TakePhotoModal from '../../components/Models/TakePhotoModal';
import ProductNotSave from '../../components/Models/ProductNotSave';
import withReadOnlyProductNotes from '../../common/withReadOnlyProductNotes';
import DollarSign from '../../assets/images/dollarSign@3x.png';

class ProductList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      productsData: [],
      productNotes: '',
      dgrsCount: 0,
      dgrKey: '',
      caseRes: {},
      NeedPrice: false,
      hospitalNeedPrice: false,
      PriceSheet: false,
      caseData: {},
      hospitalLineItem: false,
      capMessageLoaded: '',
      showPriceFlag: false,
      showTotalPriceFlag: false,
      totalProductPrice: 0,
    };
    // this.selectFileOrTakePhoto = null;
    // this.takePhotoModal = null;
    this.caseChangesNoLonger = null;
    this.ProductNotSaveModal = null;
  }

  componentDidMount() {
    try {
      // this.selectFileOrTakePhoto =
      // new window.bootstrap.Modal(window.$('#selectFileOrTakePhoto'));
      // this.takePhotoModal = new window.bootstrap.Modal(window.$('#takePhotoModal'));
      this.caseChangesNoLonger = new window.bootstrap.Modal(window.$('#CaseChangesNoLongerModal'));
      this.ProductNotSaveModal = new window.bootstrap.Modal(window.$('#ProductNotSaveModal'));
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getProductList = async () => {
    try {
      const { params: { id }, tableName } = this.props;
      // const caseRes = await getCaseByCaseId(id);
      const caseRes = await getTableCaseByCaseId(id, tableName);
      if (caseRes && caseRes.case_products.length > 0) {
        this.setState({
          productsData: caseRes.case_products,
          productNotes: caseRes.ProductNotes,
          dgrKey: caseRes.DGR
        });
      } else {
        this.setState({
          productsData: caseRes.case_products,
          productNotes: caseRes.ProductNotes,
          dgrKey: caseRes.DGR
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getDgrsCount = async () => {
    try {
      const { params: { id }, tableName } = this.props;
      const caseRes = await getTableCaseByCaseId(id, tableName);
      if (caseRes) {
        this.setState({
          dgrsCount: caseRes.case_dgrs.length,
          caseRes
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGoBack = () => {
    try {
      const { goBack, setGoBack } = this.props;
      goBack.push(window.location.pathname);
      setGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onACMProductNotes = () => {
    try {
      const { params: { id } } = this.props;
      this._onGoBack();
      browserHistory.push(`/manage-case/${id}/products/add/notes`);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  /* _onACMProductDGR = async () => {
    const { params: { id } } = this.props;
    const { dgrsCount } = this.state;
    if (dgrsCount > 0) {
      this._onGoBack();
      browserHistory.push(`/manage-case/${id}/products/dgr`);
    } else {
      this.takePhotoModal.show();
    }
  } */

  _onProductAdd = async () => {
    try {
      const { caseData } = this.state;
      if (caseData.DGR === '1') {
        this.ProductNotSaveModal.show();
      } else {
        const {
          params: { id }, tableName, user: { scanner }, notify
        } = this.props;
        const caseDetailsRes = await getTableCaseByCaseId(id, tableName);
        if (scanner === false && caseDetailsRes.case_products.length > 0) {
          notify({
            type: 'error',
            message: 'Scanning is not enabled for your account. Please contact your office if you need to scan'
          });
          this._onGoBack();
          browserHistory.push(`/manage-case/${id}/products/add`);
        }
        this._onGoBack();
        browserHistory.push(`/manage-case/${id}/products/add`);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSelectImage = async (formData, value) => {
    try {
      const {
        setLoader, notify, online, params: { id }, tableName
      } = this.props;
      const caseDetailsRes = await getTableCaseByCaseId(id, tableName);
      if (caseDetailsRes && caseDetailsRes.DGR === '1') {
        this.caseChangesNoLonger.show();
        return;
      }
      const body = (value === 'dgr') ? formData : formData.files[0];
      setLoader(true);
      if (online) {
        // this.selectFileOrTakePhoto.hide();
        // this.takePhotoModal.hide();
        uploadDgr({
          CaseScheduleID: caseDetailsRes.CaseScheduleID,
          OriginalFile: body
        }).then(async (responseJson) => {
          setLoader(false);
          const { status, message, data } = responseJson;
          if (status) {
            if (message.length > 0) {
              // notify({ type: 'success', message });
            }
            // Update into local db
            caseDetailsRes.case_dgrs.push(data);
            await updateCase(caseDetailsRes);
            await updateTableWiseCaseByCaseId(caseDetailsRes.RepCaseNo, caseDetailsRes, tableName);
            this.setState({ OriginalFile: data.OriginalFileName });
            await this._getDgrsCount();
          } else {
            notify({ type: 'error', message });
          }
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onTakePhotoFile = async (formData) => {
    try {
      const {
        setLoader, notify, online, params: { id }, tableName
      } = this.props;
      const caseDetailsRes = await getTableCaseByCaseId(id, tableName);
      if (caseDetailsRes && caseDetailsRes.DGR === '1') {
        this.caseChangesNoLonger.show();
        return;
      }
      const body = formData;
      setLoader(true);
      if (online) {
        this.takePhotoModal.hide();
        uploadDgr({
          CaseScheduleID: caseDetailsRes.CaseScheduleID,
          OriginalFile: body
        }).then(async (responseJson) => {
          setLoader(false);
          const { status, message, data } = responseJson;
          if (status) {
            if (message.length > 0) {
              // notify({ type: 'success', message });
            }
            // Update into local db
            caseDetailsRes.case_dgrs.push(data);
            await updateCase(caseDetailsRes);
            await updateTableWiseCaseByCaseId(caseDetailsRes.RepCaseNo, caseDetailsRes, tableName);
            await this._getDgrsCount();
          } else {
            notify({ type: 'error', message });
          }
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onClickDgrs = () => {
    try {
      const {
        params: { id }, online, notify, setReadOnlyProductNotes
      } = this.props;
      if (online) {
        setReadOnlyProductNotes(true);

        this._onGoBack();
        browserHistory.push(`/manage-case/${id}/products/dgr`);
      } else {
        notify({ type: 'error', message: 'DGRs cannot be viewed without an internet connection' });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getById = async () => {
    try {
      const {
        params: { id }, tableName, online
      } = this.props;

      let caseRes = await getTableCaseByCaseId(id, tableName);
      const hosptalRes = await getHospitalByCustomerNo(caseRes.CustomerNo);
      if (typeof hosptalRes !== 'undefined') {
        this.setState({
          hospitalNeedPrice: hosptalRes.NeedPrice === '1',
          hospitalLineItem: hosptalRes.LineItem === '1',
        });
      }

      if (online) {
        if (caseRes !== null) {
          let _ignore;
          // eslint-disable-next-line no-unused-vars
          [caseRes, _ignore] = (await listSingleCase(caseRes.CaseScheduleID)).data;
        }
      }
      // Get case time
      const currentDate = new Date();
      const timeValues = caseRes.CaseTime.split(':');
      const CaseDateTime = currentDate.setHours(timeValues[0], timeValues[1]);
      if (Object.keys(caseRes).length > 0) {
        this.setState({
          selectedCaseId: (caseRes.ACMCaseID === null) ? caseRes.RepCaseNo : `${`${caseRes.RepCaseNo}(ACM)`}`,
          selectedType: caseRes.CaseType,
          selectedSurgeon: caseRes.SurgeonName,
          selectedHospital: caseRes.CustomerName,
          selectedProcedure: caseRes.ProcedureType,
          selectedSide: caseRes.Side,
          selectedCaseTime: new Date(CaseDateTime),
          selectedGender: caseRes.Gender,
          selectedCaseDate: new Date(caseRes.CaseDate.replace(/-/g, '/')),
          customerNo: caseRes.CustomerNo,
          RepNotes: caseRes.RepNotes,
          Comments: caseRes.Comments,
          NeedPrice: caseRes.NeedPrice === '1',
          PriceSheet: caseRes.PriceSheet === '1',
          caseData: caseRes,
        }, () => {
          this.setState({ fixCaseData: { ...caseRes, ...this.state } });
        });
        Object.keys(caseRes).map((key) => {
          if (key === 'RepCaseNo' && caseRes.ACMCaseID !== null) {
            const RepCaseNo = `${`${caseRes.RepCaseNo} (ACM)`}`;
            caseRes.RepCaseNo = RepCaseNo;
          }
        });
        this.setState({
          caseData: caseRes,
          manageCaseData: { ...caseRes },
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickNeedPrice = async () => {
    const { NeedPrice, caseData } = this.state;
    const {
      tableName, params: { id }, online, setLoader
    } = this.props;
    try {
      const submitData = {
        ...caseData,
        NeedPrice: !NeedPrice
      };
      setLoader(true);
      const caseDetail = await getTableCaseByCaseId(id, tableName);
      caseDetail.NeedPrice = submitData.NeedPrice ? '1' : '0';
      caseDetail.Sync = online ? 0 : 1;
      updateTableCaseByPrimaryId(id, caseDetail, tableName);
      if (online) {
        await updateCase(submitData);
      }
      this.setState({
        NeedPrice: !NeedPrice
      });
      setLoader(false);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickProductNotSave = async () => {
    try {
      const { goBack, params: { id } } = this.props;
      onGoBack(goBack);
      this.ProductNotSaveModal.hide();
      browserHistory.push(`/manage-case/${id}`);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getProductPriceById = async () => {
    try {
      const {
        params: { id }, tableName, online, notify, setLoader
      } = this.props;
      const { productsData } = this.state;
      let totalProductPrice = 0;
      let totalPriceFlag = true;
      let capMessageLoaded = '';

      const caseRes = await getTableCaseByCaseId(id, tableName);
      if (online) {
        setLoader(true);
        if (caseRes !== null) {
          const response = await getCaseProductItems(caseRes.CaseScheduleID);
          const { capPriceLoaded, case_products } = response.data;

          const newProductData = productsData.map((product) => {
            const { CaseProductsID } = product;

            const productPrice = case_products.find(
              (item) => item.CaseProductsID === CaseProductsID
            );

            if (typeof productPrice.UnitPrice !== 'undefined' && productPrice.UnitPrice !== '' && productPrice.UnitPrice !== null && productPrice.UnitPrice !== 'N/A') {
              totalProductPrice += parseFloat(productPrice.UnitPrice);

              const formattedPrice = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
              }).format(productPrice.UnitPrice);

              return {
                ...product,
                UnitPrice: formattedPrice
              };
            }

            totalPriceFlag = false;
            return {
              ...product,
              UnitPrice: 'N/A'
            };
          });

          totalProductPrice = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
          }).format(totalProductPrice);

          if (Number(capPriceLoaded) === 1 && totalPriceFlag === false) {
            capMessageLoaded = 'This customer has capitated pricing loaded in OPtimize. <br/> N/A = line-item pricing not available.';
          } else if (Number(capPriceLoaded) === 1) {
            capMessageLoaded = 'This customer has capitated pricing loaded in OPtimize.';
          } else if (totalPriceFlag === false) {
            capMessageLoaded = 'N/A = line-item pricing not available.';
          }

          this.setState({
            productsData: newProductData,
            capPriceLoaded,
            showPriceFlag: true,
            showTotalPriceFlag: totalPriceFlag,
            totalProductPrice,
            capMessageLoaded
          });
        }
        setLoader(false);
      } else {
        notify({
          type: 'error',
          message: 'You must have an internet connection. Please check your connection and try again.',
          time: 5
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  async UNSAFE_componentWillMount() {
    try {
      const {
        params: { id }, setLoader
      } = this.props;
      setLoader(true);
      if (id) {
        await this._getById();
      }
      await this._getProductList();
      await this._getDgrsCount();

      setLoader(false);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const { goBack } = this.props;
    const {
      productsData, productNotes, dgrsCount, dgrKey,
      caseRes, NeedPrice, PriceSheet, hospitalNeedPrice,
      hospitalLineItem, capMessageLoaded, showPriceFlag,
      showTotalPriceFlag, totalProductPrice
    } = this.state;

    return (
      <section className="list-section">
        <Header
          actionButton={(dgrKey === '0') && {
            title: 'Edit',
            onClick: this._onProductAdd,
          }}
          title="Products"
          goBack={() => onGoBack(goBack)}
        />
        <section
          className="sets-section resizer-class"
          style={{
            marginBottom: '50px'
          }}
        >
          <div className="container">
            <div className="top-block">
              <div className="row">
                <div className="col">
                  <div className="d-flex align-items-center gap-2">
                    <h2 className="product-text">
                      Products: {productsData.length}
                    </h2>
                    {
                      !PriceSheet && hospitalLineItem && (
                        <h2
                          role="presentation"
                          className="product-text cursor-pointer"
                          onClick={this._getProductPriceById}
                        >
                          <img
                            src={DollarSign}
                            alt="icon"
                          />
                        </h2>
                      )
                    }
                  </div>
                </div>

                <div className="col justify-content-center align-items-center d-inline-flex">
                  {
                    caseRes.VelysUsed !== null && (
                      <div className="d-flex align-items-center gap-2">
                        <h2
                          role="presentation"
                          className="product-text-used"
                        >
                          <img
                            src={VelysLogoBlue}
                            alt="icon"
                          />
                        </h2>

                        <h2 className="product-text-used">
                          {caseRes.VelysUsed === 'YES' ? 'Used' : 'Not Used'}
                        </h2>

                        {/* <div className="product-text-used d-flex">
                          <p className="ms-1 mb-0" style={{ whiteSpace: 'nowrap' }}></p>
                        </div> */}

                      </div>
                    )
                  }
                </div>

                <div className="col justify-content-end align-items-center d-inline-flex">
                  {
                    !PriceSheet && hospitalNeedPrice && (
                      <div
                        className="form-check d-flex align-items-center"
                      // style={{
                      //   display: 'flex', alignItems: 'center', margin: 0, height: 0
                      // }}
                      >
                        <input
                          id="needPrice"
                          name="needPrice"
                          type="checkbox"
                          checked={NeedPrice}
                          className="form-check-input"
                          style={{ height: 18, width: 18, marginRight: 6 }}
                          onChange={() => this._onClickNeedPrice()}
                        />
                        <label className="form-check-label" htmlFor="needPrice" style={{ whiteSpace: 'nowrap', marginBottom: 0 }}>Need Price</label>
                      </div>
                    )
                  }
                </div>
              </div>
            </div>

            <div className="sets-list-blocks p-0">
              <div className="sets-block mb-4">
                <ul className="list-unstyled listUnstyled">
                  {
                    productsData && productsData.map((product, key) => (
                      <li key={key}>
                        <div className="contents-wrap">
                          <div className="row gx-2">

                            <div className="col">
                              <p>{product.ProductNo}</p>
                            </div>

                            <div className="col-6 col-md-5">
                              <p className="lot-number">{product.LotNo}</p>
                            </div>

                            <div className="col-3">
                              <p className="text-end pe-2">
                                {product.Wasted === '1' ? 'Wasted' : ''}
                              </p>
                              <p className={`text-end pe-2 ${!showPriceFlag ? 'd-none' : ''}`}>
                                {
                                  typeof product.UnitPrice !== 'undefined' && product.UnitPrice !== null ? product.UnitPrice : ''
                                }
                              </p>
                            </div>
                          </div>
                          <p>{product.ProductDescription}</p>
                        </div>
                      </li>
                    ))
                  }

                  {
                    showTotalPriceFlag && showPriceFlag && (
                      <li key={productsData.length}>
                        <div className="contents-wrap">
                          <div className="row gx-2">

                            <div className="col">
                              <p />
                            </div>

                            <div className="col-6 col-md-5 text-end">
                              <p className="lot-number">Total: </p>
                            </div>

                            <div className="col-3">
                              <p className="text-end pe-2">
                                {
                                  totalProductPrice
                                }
                              </p>
                            </div>
                          </div>
                        </div>
                      </li>
                    )
                  }

                </ul>
              </div>
            </div>
          </div>
        </section>

        <section className="sets-footer-section fixed-bottom">
          <div className="container">
            <div className="button-block">
              <div className="row gx-2">
                <div className="col-12 text-center">
                  {/* eslint-disable react/no-danger */}
                  <p dangerouslySetInnerHTML={{ __html: capMessageLoaded }} />
                  {/* eslint-enable react/no-danger */}
                </div>
                <div className="col-12 text-center">
                  <button
                    type="button"
                    className={`btn btn-sm btn-theme-alt btn-theme-outline-alt ${productNotes ? 'active' : ''}`}
                    onClick={this._onACMProductNotes}
                  >Notes
                  </button>&nbsp;
                  <button
                    type="button" className="btn btn-sm btn-theme-alt btn-theme-outline-alt"
                    onClick={this._onClickDgrs}
                  >
                    DGRs: {dgrsCount}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <TakePhotoModal onTakePhotoFile={this._onTakePhotoFile} />
        <SelectFileOrTakePhoto
          onSelectImage={this._onSelectImage} onTakePhoto={this._onSelectImage}
        /> */}
        <CaseChangesNoLonger
          id={caseRes.id}
        />
        <ProductNotSave
          onClickYes={this._onClickProductNotSave}
          onMessage=""
        />
      </section>
    );
  }
}

export default withUser(
  withNotify(
    withLoader(
      withOnline(
        withTableName(
          withGoBack(
            withReadOnlyProductNotes(
              ProductList
            )
          )
        )
      )
    )
  )
);
